import React, { useEffect, useState } from "react";
import { ArrowLeft, ArrowRight, Building2, HeartPulse, Search, ShieldCheck, Stethoscope } from "lucide-react";
import Logo from "../../Common/Logo";
import { useNavigate, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import axios from "axios";
const ACCOUNTS_URL = process.env.REACT_APP_ACCOUNTS_URL 
const PATIENT_URL = process.env.REACT_APP_PATIENT_URL 
const PRACTITIONER_URL = process.env.REACT_APP_PRACTITIONER_URL 
const PROVIDER_URL = process.env.REACT_APP_PROVIDER_URL 
const CENTRAL_ADMIN_URL = process.env.REACT_APP_CENTRAL_ADMIN_URL 
const SIGNIN_URL = process.env.REACT_APP_SIGNIN_URL

 
const TenantList = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();
  const [tenants, setTenants] = useState([]);
  const [searchParams] = useSearchParams();
  const token = searchParams.get("vt");
  const userId = searchParams.get("ui");

  useEffect(()=>{

    if(searchTerm){
        const lowerSearctTermv = searchTerm.toLowerCase();
        const filteredTenants = tenants?.filter((elm)=> elm.tenantName.toLowerCase().includes(lowerSearctTermv) || elm.userTypes.includes(lowerSearctTermv));
        setTenants(filteredTenants);
    }else{
        setTenants(tenants)
    }
  },[searchTerm])


  useEffect(() => {
    if (token && userId) {
      getProfile(token, userId);
    }
  }, [token, userId]);
  
  async function getProfile(token, userId) {
    try {
      const res = await axios.get(
        `${ACCOUNTS_URL}/profiles/profile/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setTenants(() => res.data.tenants);
      
    } catch (error) {
      console.log(error);
    }
  }

  async function handleTenantClick(tenantId,userType){

    let url  = SIGNIN_URL

    if(userType==='patient'){
        url =  `${PATIENT_URL}?vt=${token}&ui=${userId}&ti=${tenantId}`
    }else if(userType==="provider"){
         url =  `${PROVIDER_URL}?vt=${token}&ui=${userId}&ti=${tenantId}` 
    }else if(userType==="central_admin"){
      url =  `${CENTRAL_ADMIN_URL}?vt=${token}&ui=${userId}&ti=${tenantId}`
    }else if(userType==="practitioner"){
        url =  `${PRACTITIONER_URL}?vt=${token}&ui=${userId}&ti=${tenantId}`
    }
 
  


    window.location.href =  url;
  }


  return (
    <div className="min-h-screen bg-slate-50">
      <header className="border-b border-slate-200 bg-white">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-4 sm:px-6">
          <Logo />
          <button className="inline-flex items-center gap-1.5 rounded-lg px-3 py-2 text-sm font-medium text-slate-600 hover:bg-slate-100 hover:text-ink-900" onClick={() => navigate("/")}>
            <ArrowLeft className="h-4 w-4" /> Back
          </button>
        </div>
      </header>

      <main className="mx-auto max-w-4xl px-4 py-12 sm:px-6">
        <div className="text-center">
          <h1 className="text-3xl font-extrabold tracking-tight sm:text-4xl">Choose where to continue</h1>
          <p className="mx-auto mt-3 max-w-xl text-slate-600">Your account has access to more than one hospital or role. Pick the workspace you want to open.</p>
        </div>

        <div className="relative mx-auto mt-8 max-w-md">
          <Search className="pointer-events-none absolute left-4 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
          <input
            type="text"
            placeholder="Search by hospital or role"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="hf-input pl-11"
          />
        </div>

        <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2">
          {tenants && tenants.length > 0 ? (
            tenants.map((tenant, index) => {
              const role = ROLE[tenant?.userType] || { label: tenant?.userType, icon: Building2 };
              return (
                <motion.button
                  type="button"
                  key={index}
                  initial={{ opacity: 0, y: 16 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.06 }}
                  onClick={() => handleTenantClick(tenant.tenantId, tenant.userType)}
                  className="group flex items-center gap-4 rounded-2xl border border-slate-200 bg-white p-5 text-left shadow-sm transition hover:-translate-y-0.5 hover:border-brand-300 hover:shadow-soft"
                >
                  <span className="flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-brand-500 to-care-500 text-white">
                    <role.icon className="h-5 w-5" />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block truncate font-semibold text-ink-900">{tenant.tenantName}</span>
                    <span className="mt-0.5 block text-sm text-slate-500">{role.label}</span>
                  </span>
                  <ArrowRight className="h-5 w-5 text-slate-300 transition group-hover:translate-x-0.5 group-hover:text-brand-600" />
                </motion.button>
              );
            })
          ) : (
            <p className="col-span-full rounded-2xl border border-dashed border-slate-300 bg-white py-10 text-center text-slate-500">
              No workspaces match your search.
            </p>
          )}
        </div>
      </main>
    </div>
  );
};

const ROLE = {
  patient: { label: "Patient portal", icon: HeartPulse },
  practitioner: { label: "Doctor & staff workspace", icon: Stethoscope },
  provider: { label: "Hospital admin portal", icon: Building2 },
  central_admin: { label: "Platform administration", icon: ShieldCheck },
};

export default TenantList;
